import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  min-height: 50vh;
`

const ContentWrapper = styled.div`
  width: 100%;
  max-width: 320px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`

const StyledButton = styled.button`
  background: linear-gradient(145deg, #2a2a2a, #1a1a1a);
  color: #ffffff;
  border: none;
  border-radius: 16px;
  padding: 18px 24px;
  font-size: 1.1rem;
  font-weight: 600;
  letter-spacing: 0.5px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
  width: 100%;
  text-transform: uppercase;
  position: relative;
  overflow: hidden;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0));
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.25);
    background: linear-gradient(145deg, #333333, #222222);
    
    &::after {
      opacity: 1;
    }
  }

  &:active {
    transform: translateY(1px);
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }
`

const ErrorMessage = styled.div`
  color: #d32f2f;
  background-color: #ffebee;
  border: 1px solid #ffcdd2;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 24px;
  text-align: center;
  font-weight: 500;
  box-shadow: 0 2px 8px rgba(211, 47, 47, 0.1);
  animation: slideIn 0.3s ease-out;

  @keyframes slideIn {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`

const OptionSelectView = ({ onSubmit, watchLeaderboard, errorMsg, finalized }) => {
  return (
    <Container>
      <ContentWrapper>
        {errorMsg && <ErrorMessage>{errorMsg}</ErrorMessage>}
        
        {!finalized && (
          <StyledButton onClick={() => onSubmit()}>
            Keep Score
          </StyledButton>
        )}
        
        <StyledButton onClick={() => watchLeaderboard()}>
          Leaderboard
        </StyledButton>
      </ContentWrapper>
    </Container>
  )
}

export default OptionSelectView